import { apolloClient } from "@/plugins/vue-apollo.js";

const deletePropertyType = (_variables) => {
  let responseFromApi;
  let variables = {
    id: _variables,
  };
  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/property/api/mutations/propertyType/delete_property_type.graphql"),
      variables: variables,
      update: (store, { data }) => {
        const query = {
          query: require("@/property/api/queries/propertyType/property_type_query.graphql"),
          variables: {
            input: {
              limit: 10,
              skip: 0
            },
            filter: {
              searchKey: ''
            }
          },
        };
        store.writeQuery({
          ...query,
          data: data,
        });
      },
    })
    .catch((error) => {
      return error;
    });
  return responseFromApi;
};
export { deletePropertyType };
